<script setup lang="ts">
import { drawActions } from "@/action/drawActions";
import { drawAlignEdited, drawTextEdited } from "@/analytics/events/draw";
import { trackEvent } from "@/analytics/track";
import { shapeKey } from "@/components/injectKeys";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";
import type { Shape } from "@/model/shape";
import { injectStrict } from "@/utils/vue";

import TextDropdown from "./TextDropdown.vue";

const shape = injectStrict(shapeKey);

function update(label: Exclude<Shape["label"], undefined>) {
  const s = shape.value!;
  if (label?.text !== s.label?.text) {
    trackEvent(drawTextEdited());
  }
  if (label?.align !== s.label?.align) {
    trackEvent(drawAlignEdited());
  }
  s.label = { ...label };
  drawActions.editShape("context-menu", s);
}
</script>

<template>
  <ActionMenuDropdown :action="drawActions.editShape" width="auto">
    <TextDropdown @update="update" />
  </ActionMenuDropdown>
</template>
